  import axios from 'axios';
  import { store } from '../store/store';

  // Create axios instance with base configuration
  const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request interceptor to add auth token
  api.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.auth.accessToken;

      // Add Authorization only if token exists, preserve other headers
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );


  // Response interceptor to handle token refresh
  api.interceptors.response.use(
    (response) => {
      return response;
    }, 
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
          try {
          const state = store.getState();
          const refreshToken = state.auth.refreshToken;
          if (refreshToken) {
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}/user/public/refresh-token`,
              { refreshToken }
            );

            const { accessToken } = response.data.data;
            const newRefreshToken = response.data.data.refreshToken || refreshToken; // Use existing refresh token if new one not provided
            
            if (!accessToken) {
              store.dispatch({ type: 'auth/logout' });
              window.location.href = '/login';
              return;
            }
    
            store.dispatch({ type: 'auth/setTokens', payload: { accessToken, refreshToken: newRefreshToken } });
            
            // Update localStorage
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', newRefreshToken);
            
            // Retry original request with new token
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            return api(originalRequest);
          } else {
            store.dispatch({ type: 'auth/logout' });
            window.location.href = '/login';
          }
        } catch (refreshError) {
          
          // Check if refresh token API also returned 401
          if (refreshError.response?.status === 401) {
            store.dispatch({ type: 'auth/logout' });
            window.location.href = '/login';
          } else {
            store.dispatch({ type: 'auth/logout' });
            window.location.href = '/login';
          }
        }
      } else if (error.response?.status === 401 && originalRequest._retry) {
        store.dispatch({ type: 'auth/logout' });
        window.location.href = '/login';
      }
      
      return Promise.reject(error);
    }
  );

  export default api;
